
<ng-container *ngIf="userDetails?.is_oto_info; else formTemplate">
	<div class="fatoorah-show active">
		<ul>
			<li>
				<span class="name" i18n="@@payment_info.online_payment_status">OTO Delievry status :</span>
				<div class="details">
					<span class="tu-btn yellow" *ngIf="userDetails?.oto_info?.is_active == 0" i18n="@@ts.pending">Pending</span>
					<span class="tu-btn blue" *ngIf="userDetails?.oto_info?.is_active == 1" i18n="@@ts.active">Active</span>
				</div>
			</li>

			<li>
				<span class="name" i18n="@@business.available_credit">Available Credit</span>
				<span class="details">
					{{ creditAmount | number:'.2' }}  &nbsp;&nbsp;
					<a class="tu-btn blue transparent" href="javascript:;" (click)="fetchOtoClientInfo()" i18n="@@business.fetch_credit">Fetch credit</a> &nbsp;&nbsp;
					<a class="tu-btn pink transparent" href="javascript:;" (click)="addOtoCreditAmount()" i18n="@@business.add_credit">Add credit</a>
				</span>
			</li>

			<li>
				<span class="name" i18n="@@business.company_name">Company Name</span>
				<span class="details">{{ userDetails?.oto_info?.company_name | titlecase }}</span>
			</li>

			<li><span class="name" i18n="@@business.license_name">Full Name</span>
				<span class="details">{{ userDetails?.oto_info?.full_name | titlecase }}</span>
			</li>

			<li><span class="name" i18n="@@business.email">Email</span>
				<span class="details">{{ userDetails?.oto_info?.email | titlecase }}</span>
			</li>

			<li>
				<span class="name" i18n="@@business.phone">Mobile Number</span>
				<span class="details">{{ userDetails?.oto_info?.mobile_number | titlecase }}</span>
			</li>

			<li>
				<span class="name" i18n="@@business.cr_number">CR Number</span>
				<span class="details">{{ userDetails?.oto_info?.cr_number | titlecase }}</span>
			</li>

			<li>
				<span class="name" i18n="@@business.vat_numberiban">VAT Number</span>
				<span class="details">{{ userDetails?.oto_info?.vat_number | titlecase }}</span>
			</li>

			<li>
				<span class="name" i18n="@@business.address">Address</span>
				<span class="details">{{ userDetails?.oto_info?.billing_address | titlecase }}</span>
			</li>
		</ul>
		<div class="account-setting__actionButtonsWrap">
			<a href="javascript:;" class="tu-btn pink" data-toggle="modal" data-target="#confirm-modal" (click)="editForm()" i18n="@@button.edit_info">Edit info</a>
		</div>
	</div>
</ng-container>

<ng-template #formTemplate>
	<form [formGroup]="merchantForm">
		<fieldset>
			<label for="account_type" i18n="@@oto.account_type">Account Type</label>
			<select app-select2 required [options]="{
				data: accountType,
				idColumn: 'id',
				textColumn: 'name'
				}"
				[selected]="selectedAccountType ? {id: selectedAccountType.id, text: selectedAccountType.name} : null"
				i18n-data-placeholder="@@business.account_type" data-placeholder="Account Type" name="account_type"
				formControlName="account_type" (ngModelChange)="onChangeAccountType($event)" #account_type>
				<option></option>
			</select>
		</fieldset>

		<fieldset [ngClass]="{'has-error': submitted && merchantForm.controls.company_name?.errors}">
			<label i18n="@@store.company_name">Company Name</label>
			<input type="text" name="company_name" formControlName="company_name">
			<span i18n="@@error.required" class="field-error" *ngIf="(submitted || f.company_name.dirty) && f.company_name.errors?.required">Required </span>
			<span class="field-error" i18n="@@error.number_only" *ngIf="(submitted || f.company_name.dirty) && f.company_name.errors?.pattern">Please enter number only </span>
			<span class="field-error" *ngIf="f.company_name.errors?.serverError">{{ f.company_name.errors?.serverError }}</span>
		</fieldset>

		<fieldset [ngClass]="{'has-error': submitted && merchantForm.controls.email?.errors}">
			<label i18n="@@store.email">Email</label>
			<input type="text" name="email" formControlName="email">
			<span i18n="@@error.required" class="field-error" *ngIf="(submitted || f.email.dirty) && f.email.errors?.required">Required </span>
			<span class="field-error" i18n="@@error.number_only" *ngIf="(submitted || f.email.dirty) && f.email.errors?.pattern">Please enter number only </span>
			<span class="field-error" *ngIf="f.email.errors?.serverError">{{ f.email.errors?.serverError }}</span>
		</fieldset>

		<fieldset [ngClass]="{'has-error': submitted && merchantForm.controls.full_name?.errors}">
			<label i18n="@@store.full_name">Full Name</label>
			<input type="text" name="full_name" formControlName="full_name">
			<span i18n="@@error.required" class="field-error" *ngIf="(submitted || f.full_name.dirty) && f.full_name.errors?.required">Required </span>
			<span class="field-error" i18n="@@error.number_only" *ngIf="(submitted || f.full_name.dirty) && f.full_name.errors?.pattern">Please enter number only </span>
			<span class="field-error" *ngIf="f.full_name.errors?.serverError">{{ f.full_name.errors?.serverError }}</span>
		</fieldset>

		<fieldset [ngClass]="{'has-error': submitted && merchantForm.controls.mobile_number?.errors}">
			<label i18n="@@store.mobile_number">Mobile Number</label>
			<input type="text" name="mobile_number" formControlName="mobile_number">
			<span i18n="@@error.required" class="field-error" *ngIf="(submitted || f.mobile_number.dirty) && f.mobile_number.errors?.required">Required </span>
			<span class="field-error" i18n="@@error.number_only" *ngIf="(submitted || f.mobile_number.dirty) && f.mobile_number.errors?.pattern">Please enter number only </span>
			<span class="field-error" *ngIf="f.mobile_number.errors?.serverError">{{ f.mobile_number.errors?.serverError }}</span>
		</fieldset>

		<fieldset [ngClass]="{'has-error': submitted && merchantForm.controls.cr_number?.errors}">
			<label i18n="@@store.cr_number">CR Number</label>
			<input type="text" name="cr_number" formControlName="cr_number">
			<span i18n="@@error.required" class="field-error" *ngIf="(submitted || f.cr_number.dirty) && f.cr_number.errors?.required">Required </span>
			<span class="field-error" i18n="@@error.number_only" *ngIf="(submitted || f.cr_number.dirty) && f.cr_number.errors?.pattern">Please enter number only </span>
			<span class="field-error" *ngIf="f.cr_number.errors?.serverError">{{ f.cr_number.errors?.serverError }}</span>
		</fieldset>

		<fieldset [ngClass]="{'has-error': submitted && merchantForm.controls.vat_number?.errors}">
			<label i18n="@@store.vat_number">VAT Number</label>
			<input type="text" name="vat_number" formControlName="vat_number">
			<span i18n="@@error.required" class="field-error" *ngIf="(submitted || f.vat_number.dirty) && f.vat_number.errors?.required">Required </span>
			<span class="field-error" i18n="@@error.number_only" *ngIf="(submitted || f.vat_number.dirty) && f.vat_number.errors?.pattern">Please enter number only </span>
			<span class="field-error" *ngIf="f.vat_number.errors?.serverError">{{ f.vat_number.errors?.serverError }}</span>
		</fieldset>

		<fieldset [ngClass]="{'has-error': submitted && merchantForm.controls.city?.errors}">
			<label i18n="@@store.city">City</label>
			<input type="text" name="city" formControlName="city">
			<span i18n="@@error.required" class="field-error" *ngIf="(submitted || f.city.dirty) && f.city.errors?.required">Required </span>
			<span class="field-error" i18n="@@error.number_only" *ngIf="(submitted || f.city.dirty) && f.city.errors?.pattern">Please enter number only </span>
			<span class="field-error" *ngIf="f.city.errors?.serverError">{{ f.city.errors?.serverError }}</span>
		</fieldset>

		<fieldset [ngClass]="{'has-error': submitted && merchantForm.controls.billing_address?.errors}">
			<label i18n="@@oto.billing_address">Billing Address</label>
			<input type="text" name="billing_address" formControlName="billing_address">
			<span i18n="@@error.required" class="field-error" *ngIf="(submitted || f.billing_address.dirty) && f.billing_address.errors?.required">Required </span>
			<span class="field-error" i18n="@@error.number_only" *ngIf="(submitted || f.billing_address.dirty) && f.billing_address.errors?.pattern">Please enter number only </span>
			<span class="field-error" *ngIf="f.billing_address.errors?.serverError">{{ f.billing_address.errors?.serverError }}</span>
		</fieldset>

		<fieldset [ngClass]="{'has-error': submitted && merchantForm.controls.pickup_address?.errors}">
			<label i18n="@@oto.pickup_address">Pickup Address</label>
			<input type="text" name="pickup_address" formControlName="pickup_address">
			<span i18n="@@error.required" class="field-error" *ngIf="(submitted || f.pickup_address.dirty) && f.pickup_address.errors?.required">Required </span>
			<span class="field-error" i18n="@@error.number_only" *ngIf="(submitted || f.pickup_address.dirty) && f.pickup_address.errors?.pattern">Please enter number only </span>
			<span class="field-error" *ngIf="f.pickup_address.errors?.serverError">{{ f.pickup_address.errors?.serverError }}</span>
		</fieldset>

		<ng-container *ngIf="selectedAccountType.id != 'new_account'">
			<fieldset class="" [ngClass]="{'has-error': submitted && merchantForm.controls.refresh_token?.errors}">
				<label i18n="@@store.refresh_token">Refresh Token</label>
				<input type="text" name="refresh_token" formControlName="refresh_token">
				<span i18n="@@error.required" class="field-error" *ngIf="(submitted || f.refresh_token.dirty) && f.refresh_token.errors?.required">Required </span>
				<span class="field-error" *ngIf="f.refresh_token.errors?.serverError">{{ f.refresh_token.errors?.serverError }}</span>
			</fieldset>
		</ng-container>

		<div class="account-setting__actionButtonsWrap">
			<button type="submit" (click)="onSubmit(merchantForm)" class="tu-btn pink save-btn" i18n="@@button.save">Save</button>
			<button class="tu-btn pink transparent" *ngIf="userDetails?.oto_info" i18n="@@common.back" (click)="goBack()">Back</button>
		</div>
	</form>
</ng-template>